import PropTypes from "prop-types";
import React from "react";
import numeral from "numeral";
import classNames from "classnames";
import { Card, KPICard } from "@evertrue/et-components";
import IsMobileContext from "../contexts/is-mobile-context";

const PoolReportKpiSection = ({ daysLeft, solicitorsTotal, prospectsTotal, assignedProspectRate }) => {
  const isMobile = React.useContext(IsMobileContext);
  const width = isMobile ? 100 : 25;
  const RespondToKpiCard = props => (
    <KPICard width={width} className={classNames("pool-report--kpi-card", { "is-mobile": isMobile })} {...props} />
  );
  return (
    <Card className={classNames("pool-report--kpi-section", { "is-mobile": isMobile })}>
      <RespondToKpiCard title="Days Left In Period" value={daysLeft} />
      <RespondToKpiCard title="Volunteers" value={numeral(solicitorsTotal).format("0,0")} />
      <RespondToKpiCard title="Prospects" value={numeral(prospectsTotal).format("0,0")} />
      <RespondToKpiCard title="Assigned" value={numeral(assignedProspectRate).format("0%")} />
    </Card>
  );
};

PoolReportKpiSection.propTypes = {
  daysLeft: PropTypes.number,
  solicitorsTotal: PropTypes.number,
  prospectsTotal: PropTypes.number,
  assignedProspectRate: PropTypes.number,
};
export default PoolReportKpiSection;
